import Link from "next/link";

const SingleFooter = ({
  classOne,
  title,
  footerType,
  BaseUrl = "study-destinations",
  RedirectValue = "countryId",
  visibleValue = "countryName",
  FirstSection = "Study in",
}) => {
  {
    /* <li key={innerIndex}>
              <div>{value.text}</div>
            </li> */
  }

  return (
    <div className={classOne}>
      <div className="footer-widget">
        <h5 className="ft-title">{title}</h5>
        <ul className="ft-link">
          {footerType.map((value, innerIndex) => (
            <li className="has-dropdown" key={innerIndex}>
              <Link
                href={
                  !BaseUrl
                    ? `/${value?.[RedirectValue]}`
                    : `/${BaseUrl}/${value?.[RedirectValue]}`
                }
              >
                {" "}
                {FirstSection} {value?.[visibleValue]}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SingleFooter;
